import api from '../api';

export const quizService = {
    getTeacherQuizList: async (teacherId) => {
        try {
            const response = await api.get(`/quizzes/teacher/${teacherId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching teachers quizzes:', error);
            throw error;
        }
    },
    getQuestions: async (data) => {
        try {
            const response = await api.post('/questions', data);
            console.log('response from getQuestions', response.data)
            return response.data;
        } catch (error) {
            console.error('Error fetching questions:', error);
            throw error;
        }
    },
    saveQuiz: async (data) => {
        try {
            const response = await api.post('/quizzes', data);
            console.log('attempting to save quiz');
            return response.data;
        } catch (error) {
            console.log('Error saving quiz', error);
        }
    },
    getQuestion:async() => {},
    saveQuestion: async (data) => {
        try {
            const response = await api.post('/questions/save', data);
            console.log('attempting to save question');
            return response.data;
        } catch (error) {
            console.log('Error saving question', error);
        }
    }
}